export function buildSpotFormData(values, files, route, mode, reportFormOpen, reportFiles) {
    const form = values.form ?? values;
    const formData = new FormData();

    if (mode === "create") {
        formData.append("latitude", String(values.lat));
        formData.append("longitude", String(values.lng));
        formData.append("title", form.title.trim());
        formData.append("place_id", String(values.placeInfo?.id || ""));
        (values.selectedFishIds || []).forEach((id) => formData.append("fish_ids[]", String(id)));
        formData.append("description", form.description);
    } else if (mode === "editSuggestion") {
        formData.append("description", form.description);
        if (values.placeId) {
            formData.append("place_id", String(values.placeId));
        }
        const fishIds = form.fishIds instanceof Set ? [...form.fishIds] : (form.fishIds || []);
        fishIds.forEach((fid) => formData.append("fish_ids[]", String(fid)));
    }

    formData.append("roadType", form.roadType);
    formData.append("capacityPersons", String(Number(form.capacityPersons || 1)));
    formData.append("bankType", form.bankType);
    formData.append("maxDepth", mode === "editSuggestion" ? String(form.maxDepth ?? "") : form.maxDepth);
    formData.append("currentStrength", form.currentStrength);
    formData.append("isWinterHole", form.isWinterHole ? "1" : "0");
    formData.append("isSpawningArea", form.isSpawningArea ? "1" : "0");
    formData.append("tentAllowed", form.tentAllowed ? "1" : "0");
    formData.append("fishingFromShore", form.fishingFromShore ? "1" : "0");
    formData.append("fishingFromBoat", form.fishingFromBoat ? "1" : "0");
    formData.append("nightFishingAllowed", form.nightFishingAllowed ? "1" : "0");
    formData.append("suitableForChildren", form.suitableForChildren ? "1" : "0");
    formData.append("hasParking", form.hasParking ? "1" : "0");
    formData.append("hasShelter", form.hasShelter ? "1" : "0");

    (files?.place || []).forEach((file) => formData.append("place_photo[]", file));
    (files?.catch || []).forEach((file) => formData.append("catch_photo[]", file));
    (files?.depth || []).forEach((file) => formData.append("depth_photo[]", file));

    const drawPoints = route?.drawPoints || [];
    if (drawPoints.length >= 2) {
        const coordinates = drawPoints.map(([pointLat, pointLng]) => [pointLng, pointLat]);
        formData.append("routeGeometry", JSON.stringify({ type: "LineString", coordinates }));
        formData.append("routeDescription", route?.routeDescription ?? "");
    }

    if (reportFormOpen) {
        formData.append("reportSet", "1");

        formData.append("startTime", form.startTime);
        formData.append("endTime", form.endTime);
        formData.append("whatCaught", form.whatCaught ?? "");
        formData.append("baitUsed", form.baitUsed ?? "");
        formData.append("groundbait", form.groundbait ?? "");
        formData.append("depth", form.depth);
        formData.append("fishingType", form.fishingType);
        formData.append("report", form.report);

        (reportFiles?.catch || []).forEach((file) => formData.append("report_catch_photo[]", file));
    } else {
        formData.append("reportSet", "0");
    }

    return formData;
}
